var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandwatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7998 5.45647V8.8587L7.97309 10.7424L12.2472 6.456L9.45491 1.60254C9.36418 1.63137 9.27346 1.66982 9.19282 1.71787L4.55583 4.26473C4.08206 4.49539 3.7998 4.9471 3.7998 5.45647Z",
    fill: "#57B7DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97266 10.7328L13.0028 12.9913L15.2809 11.7323L12.2367 6.43677L7.97266 10.7328Z",
    fill: "#F99132"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.747 3.93794L10.6543 1.70823C10.2914 1.51602 9.85798 1.46796 9.46484 1.5929L12.2571 6.44636L14.7571 3.93794H14.747Z",
    fill: "#A98BBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2913 11.7419H15.3014C15.755 11.492 16.0272 11.0307 16.0272 10.5405V5.45641C16.0272 4.95665 15.755 4.50494 15.3014 4.24545L14.747 3.94751L12.2471 6.45593L15.2913 11.7419Z",
    fill: "#FF6D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7998 8.849V10.5309C3.7998 11.021 4.08206 11.4824 4.53567 11.7322L6.10821 12.5972L7.97309 10.7231L3.7998 8.849Z",
    fill: "#8AC539"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11816 12.6068L9.1826 14.2887C9.63622 14.5386 10.2007 14.5386 10.6543 14.2887L13.0031 13.0009L7.97296 10.7423C7.97296 10.7327 6.11816 12.6068 6.11816 12.6068Z",
    fill: "#FFBE0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandwatchIcon);
export default __webpack_public_path__ + "static/media/brandwatch-icon.a4b5345b1b772348b32fd9681b74ec03.svg";
export { ForwardRef as ReactComponent };